import Analytics from 'utils/analytics'
import analyticsMiddleware from './analytics-middleware.js'
import eventCreators from './event-creators.js'

export default analyticsMiddleware(
  eventCreators,
  event => Analytics.track(event.name, event.properties)
)



/** WEBPACK FOOTER **
 ** ./src/middlewares/analytics/index.js
 **/